// src/api/client.js
// Client API centralisé - gère les appels au backend PHP et le token - NE PAS MODIFIER

import { APP_CONFIG } from '../constants/config';

const SESSION_KEY = 'fynho_session';

// Récupère le token stocké dans la session locale (voir AuthContext)
const getStoredToken = () => {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    return session?.token || null;
  } catch {
    return null;
  }
};

// Fonction générique d'appel à l'API PHP
const request = async (endpoint, options = {}) => {
  const token = getStoredToken();

  const headers = {
    ...(options.isFormData ? {} : { 'Content-Type': 'application/json' }),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(`${APP_CONFIG.API_BASE_URL}${endpoint}`, {
    method: options.method || 'GET',
    headers,
    body: options.isFormData ? options.body : options.body ? JSON.stringify(options.body) : undefined,
  });

  let data;
  try {
    data = await response.json();
  } catch {
    throw new Error('Réponse invalide du serveur');
  }

  if (!response.ok || data.success === false) {
    const error = new Error(data.message || 'Une erreur est survenue');
    error.status = response.status;
    error.errors = data.errors;
    throw error;
  }

  return data.data;
};

export const apiClient = {
  get: (endpoint) => request(endpoint, { method: 'GET' }),
  post: (endpoint, body) => request(endpoint, { method: 'POST', body }),
  put: (endpoint, body) => request(endpoint, { method: 'PUT', body }),
  delete: (endpoint) => request(endpoint, { method: 'DELETE' }),
  uploadFile: (endpoint, formData) =>
    request(endpoint, { method: 'POST', body: formData, isFormData: true }),
};

export default apiClient;